var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 104,
    viewBox: "0 0 208 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 104C1.19397e-06 90.3425 2.69004 76.8188 7.91653 64.2009C13.143 51.583 20.8036 40.1182 30.4609 30.4609C40.1182 20.8036 51.5831 13.143 64.201 7.91652C76.8188 2.69003 90.3426 -5.04715e-06 104 0C117.658 5.04717e-06 131.181 2.69005 143.799 7.91655C156.417 13.143 167.882 20.8036 177.539 30.4609C187.196 40.1182 194.857 51.5831 200.083 64.201C205.31 76.8188 208 90.3426 208 104L192.4 104C192.4 92.3912 190.113 80.896 185.671 70.1708C181.228 59.4456 174.717 49.7005 166.508 41.4918C158.3 33.2831 148.554 26.7716 137.829 22.3291C127.104 17.8865 115.609 15.6 104 15.6C92.3912 15.6 80.896 17.8865 70.1708 22.329C59.4456 26.7716 49.7005 33.283 41.4918 41.4917C33.2831 49.7004 26.7716 59.4456 22.3291 70.1708C17.8865 80.896 15.6 92.3911 15.6 104H0Z",
    fill: "#BFC3CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 104C1.43481e-06 87.5877 3.88431 71.4084 11.3353 56.785C18.7864 42.1615 29.5925 29.5091 42.8704 19.8622L57.5415 40.0553C47.4503 47.3869 39.2376 57.0028 33.5748 68.1166C27.9121 79.2304 24.96 91.5267 24.96 104H0Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolution);
export default __webpack_public_path__ + "static/media/resolution.b5d5b836.svg";
export { ForwardRef as ReactComponent };